export const validateAppVersionsOnChange = (name, value, preserveError) => {
   let errors = { ...preserveError };
   switch (name) {
      case "os":
         if (!value) {
            errors.os = "Please enter device os";
         } else {
            delete errors.os
         }
         break;
      case "versionCode":
         if (!value) {
            errors.versionCode = "Please select version code";
         } else {
            delete errors.versionCode
         }
         break;
      case "versionName":
         if (!value) {
            errors.versionName = "Please enter version name";
         } else {
            delete errors.versionName
         }
         break;
      case "description":
         if (!value) {
            errors.description = "Please enter description";
         } else {
            delete errors.description
         }
         break;
      default:
         break;
   }

   return errors;
};

export const validateAppVersion = (appVersionData = {}) => {
   const {
      os,
      versionCode,
      versionName,
      description,
   } = appVersionData

   const errors = {}

   if (!os) {
      errors.os = "Please enter device os";
   }

   if (!versionCode) {
      errors.versionCode = "Please enter version code";
   }

   if (!versionName) {
      errors.versionName = "Please enter version name";
   }

   if (!description) {
      errors.description = "Please enter description";
   }

   return errors
}
